import { InfraredJob } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateInfraredJobArgs,
    getDefaultInfraredJobCreateArgs,
    UpdateInfraredJobArgs,
} from "@nova/serializer/src/client/validators/jobs/infrared"
import { selectActivatedFireId } from "features/map/control/selectors"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectUserEmail, selectUserLicense } from "user/profile/selectors"
import { addEntitySocket } from "features/entity-caching/project/slice"

const { create: createInfraredJob, createAction } = generateGenericCases<
    InfraredJob, // entity type
    CreateInfraredJobArgs, // create args to send to server
    ["processingMode"], // create args required by action
    UpdateInfraredJobArgs, // update args
    { flightId: string; imageCount?: number }, // input context
    {
        flightId: string
        portfolioName: string
        orgId: string
        userEmail: string
        fireId: string
        licenseId: string
        imageCount?: number
    } // server context
>("InfraredJob")

export const addInfraredJobsToBuilder = (builder: Builder) =>
    builder.addCase(createAction, (store, { payload: { data, context } }, socket) => {
        const state = store.getState()
        const flightId = context.flightId
        const projectId = selectActivatedFireId(state)!
        const org = selectActiveWorkspace()(state)!
        const userEmail = selectUserEmail(state)!
        const license = selectUserLicense(state)
        createInfraredJob(socket, data, {
            flightId,
            fireId: projectId,
            orgId: org.id,
            portfolioName: org.name,
            licenseId: license?.licenseId ?? "",
            userEmail,
            imageCount: context.imageCount,
        })
        store.dispatch(
            addEntitySocket({
                data: { ...getDefaultInfraredJobCreateArgs(), ...data, resourceName: "mock" },
                path: ["infraredFlights", { id: flightId }, "job"],
            })
        )
    })
// cannot update infrared job from frontend

export { createAction as createInfraredJob }
